import React from 'react';
import { withTranslation } from 'react-i18next';
import { FaHome, FaRedo } from 'react-icons/fa';
import NavBar from './nav';
import { Footer } from './footer';

const DG = 'rgb(5, 70, 37)';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('Erreur non interceptée:', error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const { t } = this.props;

    return (
      <>
        <NavBar />
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 pt-24 pb-16">
          <div className="max-w-xl w-full text-center">
            <p className="text-8xl font-bold" style={{ color: DG }}>500</p>
            <h1 className="mt-4 text-2xl sm:text-3xl font-bold text-gray-900">
              {t('errorBoundary.title')}
            </h1>
            <p className="mt-3 text-gray-600">
              {t('errorBoundary.subtitle')}
            </p>

            <div className="mt-8 flex items-center justify-center gap-3">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-white font-semibold text-sm transition-opacity hover:opacity-90"
                style={{ backgroundColor: DG }}
              >
                <FaRedo size={14} />
                {t('errorBoundary.reload')}
              </button>
              <a
                href="/"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border font-semibold text-sm text-gray-700 hover:bg-gray-100"
              >
                <FaHome size={14} />
                {t('errorBoundary.backToHome')}
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default withTranslation()(ErrorBoundary);
